import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "componentName", "screen", "subscreen", "threshold", "trackOnce", "usageTracker"];
import { useUserCanEditBilling } from '../../hooks/useUserCanEditBilling';
import { BaseViewTracker } from './BaseViewTracker';
import { EVENT_NAMES, EVENT_NAMESPACE } from './eventProperties';
import { jsx as _jsx } from "react/jsx-runtime";
export const ComponentViewTracker = _ref => {
  let {
      children,
      componentName,
      screen,
      subscreen,
      threshold = 0.25,
      trackOnce = true,
      usageTracker
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const userCanEditBilling = useUserCanEditBilling();
  const handleTrack = tracker => {
    tracker.track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_VIEWED, Object.assign({
      isBillingAdmin: userCanEditBilling,
      screen,
      component: componentName
    }, subscreen && {
      subscreen
    }, rest));
  };
  return /*#__PURE__*/_jsx(BaseViewTracker, {
    threshold: threshold,
    trackOnce: trackOnce,
    usageTracker: usageTracker,
    onTrack: handleTrack,
    children: children
  });
};